






































































































































































































































































import Button from '@/app/ui/components/Button/index.vue'
import CloseLine from '@/app/ui/assets/close_line.vue'
import IcsFProfile from '@/app/ui/assets/ics_f_profile.vue'
import IcsFPhone from '@/app/ui/assets/ics_f_phone.vue'
import IcsFLocationPin from '@/app/ui/assets/ics_f_location_pin.vue'
import IcsOBikeWhite from '@/app/ui/assets/ics_o_bike_white.vue'
import IconCancelTask from '@/app/ui/assets/icon_cancel_task.vue'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import PickupController from '@/app/ui/controllers/PickupController'
import { PickupNfdShipperHashDetail } from '@/domain/entities/Pickup'
import { Utils } from '@/app/infrastructures/misc'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PaginationNav, { IOption } from '@/app/ui/components/PaginationNav/index.vue'

@Component({
  components: {
    Button,
    CloseLine,
    IcsFProfile,
    IcsFPhone,
    IcsFLocationPin,
    IcsOBikeWhite,
    IconCancelTask,
    PaginationNav,
    EyeIcon,
    EyeDisabledIcon
  },
})
export default class CrrnfdShipmentListModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean
  @Prop({ type: String, default: '' }) readonly shipperHash!: string

  controller = PickupController

  phoneRevealed = false
  addressRevealed = false

  sort = { name: '' as string, direction: '' as 'ASC' | 'DESC' | '' }
  params = {
    page: 1,
    perPage: 10
  }
  perPageOptions: IOption[] = [
    { label: '10', value: 10 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ]

  get isLoading(): boolean {
    return this.controller.isLoadingPickupNfdShipperDetail
  }

  get detail(): PickupNfdShipperHashDetail | null {
    return this.controller.pickupNfdShipperHashDetail
  }

  get detailTotalItems(): number {
    return this.controller.pickupNfdShipperHashDetail?.pagination.totalItem ?? 0
  }

  get rowIndexBase(): number {
    const p = this.detail?.pagination
    if (!p) return 0
    const page = Math.max(1, Number(p.page) || 1)
    const per = Math.max(1, Number(p.perPage) || 10)
    return (page - 1) * per
  }

  get courierLine(): string {
    const c = this.detail?.lastCourier
    if (!c || (!c.courierId && !c.courierName)) {
      return '—'
    }
    const phone = this.formatPhoneDisplay(c.courierPhone)
    const phonePart = phone ? ` ${phone}` : ''
    const courierType = c.courierType ? ` (${c.courierType})` : ''
    return `[${c.courierId || '—'}] ${c.courierName || ''}${courierType}`.trim()
  }

  get courierLineAgent(): string {
    const c = this.detail?.lastCourier
    if (!c || (!c.agentCode && !c.agentName)) {
      return '—'
    }

    const agentName = c.agentName ? ` ${c.agentName}` : ''
    const agentCode = c.agentCode ? ` [${c.agentCode}]` : ''
    return `${agentName}${agentCode}`.trim()
  }

  @Watch('visible')
  @Watch('shipperHash')
  onOpenChange(): void {
    if (this.visible && this.shipperHash) {
      this.phoneRevealed = false
      this.addressRevealed = false
      this.sort = { name: '', direction: '' }
      this.params = {page: 1, perPage: 10}
      void this.load()
    }
  }

  public formatNFDClass(value: string | number): string {
    const status = parseInt(String(value), 10)
    if (status === 1) return 'one'
    if (status === 2) return 'two'
    if (status === 3) return 'three'
    if (status === 4) return 'four'
    if (status === 5) return 'five'
    return 'more'
  }

  public mapsHref(lat: string, lon: string): string {
    const latLon = `${lat},${lon}`
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      latLon
    )}`
  }

  public waDigits(phone: string): string {
    return String(phone || '').replace(/\D/g, '')
  }

  public formatPhoneDisplay(phone: string): string {
    const raw = String(phone || '').trim()
    if (!raw) return ''
    const d = this.waDigits(raw)
    if (!d) return raw
    if (raw.startsWith('+')) return `+${d}`
    if (d.startsWith('62')) return `+${d}`
    if (d.startsWith('0')) return `+62${d.slice(1)}`
    return `+${d}`
  }

  public crrnfdDatePart(iso: string): string {
    if (!iso) return '—'
    return Utils.formatDateWithIDLocale(iso, 'DD MMM YYYY')
  }

  public crrnfdTimePart(iso: string): string {
    if (!iso) return ''
    return Utils.formatTimeZone(Utils.formatDateWithIDLocale(iso, 'HH:mm Z'))
  }

  public onPaginationPageInput(): void {
    this.load()
  }

  public onPaginationPerPageChange(val: number): void {
    this.params.page = 1
    this.params.perPage = Number(val)
    this.load()
  }

  private async load(): Promise<void> {
    try {
      await this.controller.fetchPickupNfdByShipperHash({
        shipperHash: this.shipperHash,
        params: {
        page: this.params.page,
        perPage: this.params.perPage,
        sortField: this.sort.name,
        sortDirection: this.sort.direction,
      }
      })
    } catch {
      /* notified in controller */
    }
  }

  public onToggleSort(): void {
    this.sort.direction = this.sort.direction === 'DESC' ? 'ASC' : 'DESC'
    void this.load()
  }

  get senderPhoneValue(): string {
    return this.detail?.senderPhone || ''
  }

  get senderAddressValue(): string {
    return this.detail?.senderAddress || ''
  }

  async showPhone(): Promise<void> {
    const d = this.detail
    if (!d) return
    try {
      const resp = await this.controller.adminContactShow({
        resource: 'shipper_hash',
        resourceId: d.shipperHash,
        field: 'sender_phone',
        source: 'pickup_crrnfdv2_modal_list'
      })
      d.senderPhone = resp.value || '-'
    } finally {
      /* revealed regardless — eye toggle is local UI */
    }
    this.phoneRevealed = true
  }

  hidePhone(): void {
    this.phoneRevealed = false
  }

  async showAddress(): Promise<void> {
    const d = this.detail
    if (!d) return
    try {
      const resp = await this.controller.adminContactShow({
        resource: 'shipper_hash',
        resourceId: d.shipperHash,
        field: 'sender_address',
        source: 'pickup_crrnfdv2_modal_list'
      })
      d.senderAddress = resp.value || '-'
    } finally {
      /* revealed regardless */
    }
    this.addressRevealed = true
  }

  hideAddress(): void {
    this.addressRevealed = false
  }

  public onClose(): void {
    this.$emit('close')
  }
}
